module.exports = __webpack_public_path__ + "static/media/icono_produccion_audiovisual.987644c8.svg";